import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create ShowAllAnnotations action
 */
export function createShowAllAnnotations(
  store: Store,
  storeActions: StoreActions,
): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.ShowAllAnnotations,
    action: CONTEXT_MENU_ACTION_NAMES.ShowAllAnnotations,
    isVisible,
    handler,
  };

  /**
   * Visible if annotations are hidden
   */
  function isVisible() {
    return store.annotationsHidden.get();
  }

  /**
   * handler to show annotations
   */
  function handler(): void {
    storeActions.setAnnotationsHidden(false);
  }
}
